import{base32 as e}from"rfc4648";const o={loose:!0},a={pad:!1};var r={decode:a=>a&&e.parse(a,o),encode:o=>o&&e.stringify(o,a)};export{r as default};
//# sourceMappingURL=base32.js.map
